import CopyIcon from "@atlaskit/icon/core/copy";
import {AnankeDropdownItem} from "@vesta/ananke/components/anankeDropdownItem";
import type {useAnankeFlags} from "@vesta/ananke/hooks/useAnankeFlags";
import {copyDataToClipboard} from "~/utilities/utilities";

export function CopyDataDropdownItem<T extends Record<string, unknown>>({
    data,
    showFlag,
    transformer,
}: {
    data: T;
    showFlag: ReturnType<typeof useAnankeFlags>["showFlag"];
    transformer?: (key: string) => string;
}) {
    return (
        <AnankeDropdownItem
            onClick={async () => {
                await copyDataToClipboard(data, transformer);
                showFlag({
                    title: "Copied to clipboard",
                    appearance: "success",
                    isAutoDismiss: true,
                    autoDismissSeconds: 3,
                });
            }}
            elemBefore={<CopyIcon label="" />}
        >
            Copy
        </AnankeDropdownItem>
    );
}
